import { Divider, Stack } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import { ObjectsProvider } from "../context/ObjectsContext";
import { clearSession, getRoleName, hasValidToken } from "../utils/session";

export default function ProtectedLayout({ allowedRoles }) {
    if (!hasValidToken()) {
        clearSession();
        return <Navigate to="/signin" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(getRoleName())) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <ObjectsProvider>
        <Stack
            sx={{
                width: "100vw",
                height: "100vh",
                overflow: "hidden",
                background: "var(--bg)",
            }}
        >
            <Stack sx={{ width: "100%", height: "60px" }}>
                <Navbar />
                <Divider />
            </Stack>

            <Stack
                sx={{
                    flex: 1,
                    width: "100%",
                    height: "calc(100vh - 60px)",
                    flexDirection: "row",
                }}
            >
                <Stack
                    sx={{
                        display: {
                            xs: "none",
                            sm: "flex",
                            height: "100%",
                            flexDirection: "row",
                        },
                    }}
                >
                    <Sidebar />
                    <Divider orientation="vertical" />
                </Stack>

                <Stack
                    sx={{
                        flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        p: { xs: 2, sm: 2.5, md: 3 },
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <Stack sx={{ width: "100%", maxWidth: 1400, mx: "auto" }}>
                        <Outlet />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
        </ObjectsProvider>
    );
}
